import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'components/DatePicker';
import ValidatedFormInput from 'components/ValidatedFormInput';

function ValidatedDatePicker({ input, meta }) {
  return (
    <DatePicker
      onChange={input.onChange}
      selected={input.value}
      customInput={<ValidatedFormInput meta={meta} input={input} />}
    />
  );
}

ValidatedDatePicker.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

export default ValidatedDatePicker;
